import { BASIC_INITIAL_STATE } from '@usas/ui-web/utils/HttpHelper';
import { API_NAMES, initApi } from "@usas/ui-web/utils/HttpApiHelper";

const deleteOrganizationStaffData = (personOrgRoleDurationId, state, setState) => {
  if (personOrgRoleDurationId > 0 && state.isSaving !== true && !state.message) {
    const api = initApi(API_NAMES.PERSON, state, setState);
    const personOrgRoleDurationIdForUrl = personOrgRoleDurationId ? encodeURIComponent(personOrgRoleDurationId) : 'NaN';
    const url = `/PersonOrgRoleDuration/${personOrgRoleDurationIdForUrl}`;

    return api?.executeObject ? api.executeObject(url, 'DELETE', personOrgRoleDurationIdForUrl) : null;
  }
};

const OrganizationStaffData = { 
  INITIAL_STATE: BASIC_INITIAL_STATE, 
  deleteOrganizationStaffData };

export default OrganizationStaffData;
